import { ILanguage } from "./company";

export type GalleryItemType = "image" | "video";

export interface IContent {
  id: number;
  convertedPagesNumber: number;
  totalPagesNumber: number;
  originalFileName: string;
  creationDate: string;
  files: IFileAnnotation[];
  baseUrl: string;
  language: ILanguage;
  status: string;
}



export interface IContentDataDtoWithTypology {
  id:number
  convertedPagesNumber: number;
  totalPagesNumber: number;
  originalFileName: string;
  creationDate: string;
  files: FileTypeDto[];
  baseUrl: string;
  language: ILanguage;
  status: string;
  typology :string
}


export interface FileTypeDto{
   fileId : number;
   type: string;
   hasNote: boolean;
}

export interface IFileAnnotation {
  fileId: number;
  hasNote: boolean;
}

export interface IFileType extends IFileAnnotation {
  type: GalleryItemType;
}

export interface IPlayerContent {
  sourceName: string;
  documentName: string;
  contentData: IContentDataDtoWithTypology;
  availableLanguages: ILanguage[];
  languageId: number;
}

export interface IGenericGalleryContent {
  name: string
  totalPagesNumber: number;
  files: IFileType[];
  baseUrl: string;
}

export interface IContentTitles {
  source: string;
  document: string;
}

export interface IContentLanguages {
  availabeLanguages: ILanguage[];
  languageId: number;
}

// new model used by GenericTeletabberGallery.tsx
export interface IGalleryElement {
  original: string;
  thumbnail: string;
  type: GalleryItemType;
  index: number;
  fileId: number;
  hasNote: boolean;
  totalNumber: number;
}

export interface IBrowserPageContent {
  items: IGalleryElement[];
  title: IContentTitles;
  contentId?: number;
  languages?: IContentLanguages;
  typology: string

}

export interface IZwibblerDrawingFormValues {
  fileId: number;
  data: string;
}

export interface IZwibblerDrawing {
  data: string;
  status: number;
  statusText: string;
}

export const getUploadAssetUrl = (
  folder: string,
  path: string,
  imgType: "logo" | "sidebar" | "favicon" | "background"
) => {
  return `${process.env.REACT_APP_API_URL}/public/content/img/${folder}${
    path.startsWith("/") ? path : "/" + path
  }/${imgType}`;
};

export const getExistingAssetUrl = (
  folder: string,
  path: string,
  filename: "logo.png" | "logo_sidebar.png" | "favicon.ico" | "background.png"
) => {
  return `${process.env.REACT_APP_LOGO_PATH}img/${folder}${
    path.startsWith("/") ? path : "/" + path
  }/${filename}`;
};
